














import { Component, Vue } from 'vue-property-decorator'
import locale from 'ant-design-vue/lib/locale-provider/ru_RU'
import Sidebar from '@/components/app/Sidebar.vue'
import Header from '@/components/app/Header.vue'

@Component({
  components: {
    Sidebar,
    AppHeader: Header
  }
})
export default class App extends Vue {
  sidebarCollapsed = false
  locale = locale
}
